import React, { useState } from 'react'
import className from 'classnames'

import { LoadingSpinner } from '@elo-kit/components/loading-spinner/LoadingSpinner'
import CommunityFileUploadWidget from 'shared/components/community/components/file-upload-widget/CommunityFileUploadWidget'

import { FILE_UPLOAD_ACCEPT_POST_EXTENSIONS, FILE_UPLOAD_ACCEPT_POST_FILES } from 'constants/files.constants'

import { withStores } from 'utils/helpers.utils'
import { getFileExtension } from '@elo-kit/utils/files.utils'

import { notify } from 'libs/common/notify'

import ImageCrop from '../ImageCrop'
import { CommunityModal } from '../community-modal/CommunityModal'

const CropImageModal = (props) => {
  const {
    coversStore = {},
    image,
    onCrop,
    onRemove,
    open,
    title,
    toggleModal,
    onCancel,
    onClose,
    showFileUpload = true,
    submitButtonChild,
    circularCrop,
  } = props
  const [cropParams, setCropParams] = useState({})
  const [loadedImage, setLoadedImage] = useState(null)
  const [submitDisabled, setSubmitDisabled] = useState(false)

  const handleImageSave = () => {
    onCrop(cropParams, loadedImage || image)
  }

  const showWarningMessage = (fileExtension) => {
    const isValidFormat = FILE_UPLOAD_ACCEPT_POST_EXTENSIONS.includes(fileExtension.toLowerCase())
    setSubmitDisabled(!isValidFormat)

    if (!isValidFormat) {
      notify('error', I18n.t('react.shared.community.notific.invalid_file_type'))
    }
  }

  const uploadOwnImage = (files) => {
    const { ...uploadedFiles } = files
    const file = Object.values(uploadedFiles)[0]

    coversStore.createItem({ file }).then(({ data }) => {
      setLoadedImage(data?.url || '')
      showWarningMessage(getFileExtension(data?.file?.name))
    })
  }

  const addMediathekImage = (files) => {
    const file = Object.values(files)[0]

    if (file) {
      setLoadedImage(file.url)
      showWarningMessage(getFileExtension(file.file?.name))
    }
  }

  const uploadDropboxImage = (files) => {
    const file = files[0]

    coversStore.createItem({ fileRemoteUrl: file.link }).then(({ data }) => {
      setLoadedImage(data?.url || '')
      showWarningMessage(getFileExtension(data?.file?.name))
    })
  }

  const handleImageRemove = () => {
    setCropParams({})
    setLoadedImage(null)
    onRemove()
  }

  const handleCropChange = (crop) => setCropParams(crop)

  const communityModalClass = className('community-modal--crop-image', {
    'community-modal--with-image': image || loadedImage || coversStore.loading,
  })

  return (
    <CommunityModal
      isOpen={open}
      className={communityModalClass}
      submit={handleImageSave}
      title={title}
      toggle={toggleModal}
      onCancel={onCancel}
      onClose={onClose}
      submitButtonChild={submitButtonChild}
      submitDisabled={submitDisabled}
    >
      {coversStore.loading ? (
        <LoadingSpinner />
      ) : (
        (image || loadedImage) && (
          <ImageCrop
            image={loadedImage || image}
            onCrop={setCropParams}
            onRemove={onRemove && handleImageRemove}
            cropParams={props.cropParams}
            onCropChange={handleCropChange}
            circularCrop={circularCrop}
          />
        )
      )}

      {showFileUpload && (
        <CommunityFileUploadWidget
          formField
          id='image-loader'
          acceptedFiles={FILE_UPLOAD_ACCEPT_POST_FILES}
          fetchMediathekFiles={coversStore.fetchList}
          saveMediathekFiles={addMediathekImage}
          mediathekFiles={coversStore.list}
          mediathekModalTitle={I18n.t('react.shared.select_covers')}
          uploadFiles={uploadOwnImage}
          uploadDropboxFiles={uploadDropboxImage}
          allowMultiple={false}
          initStore={coversStore}
          description={I18n.t('react.shared.comminity.upload_image_description')}
          withImage={image || loadedImage}
        />
      )}
    </CommunityModal>
  )
}

CropImageModal.displayName = 'CropImageModal'

export default withStores(['coversStore'], CropImageModal)
